import React, {FC} from "react";
import {Switch, Tooltip} from "antd";
import {DeleteOutlined} from "@ant-design/icons";

interface ShowDeletedToggleProps {
    value: boolean;
    onChange: (value: boolean) => void;
}

/**
 * Toolbar-Switch zum Einblenden gelöschter (soft-deleted) Posten in den
 * Payments-Tabellen. Default off — Aggregations-Pfade (Summen) bleiben
 * tombstone-frei, unabhängig vom Toggle-Zustand.
 */
export const ShowDeletedToggle: FC<ShowDeletedToggleProps> = ({value, onChange}) => {
    return (
        <Tooltip title={value ? "Gelöschte Posten werden in der Tabelle angezeigt und können wiederhergestellt werden." : "Klicke, um gelöschte Posten einzublenden."} placement="top">
            <span
                style={{
                    display: "inline-flex",
                    alignItems: "center",
                    gap: 6,
                    padding: "0 8px",
                    cursor: "pointer",
                    userSelect: "none",
                }}
                onClick={() => onChange(!value)}
                data-testid="ShowDeletedToggle"
            >
                <DeleteOutlined style={{fontSize: 14, color: value ? "#ff4d4f" : "rgba(0,0,0,0.45)"}} />
                <span style={{fontSize: 13, color: "rgba(0,0,0,0.65)"}}>Gelöschte anzeigen</span>
                <Switch size="small" checked={value} onChange={onChange} onClick={(_checked, e) => e.stopPropagation()} />
            </span>
        </Tooltip>
    );
};
